import React from 'react'
import { NavLink } from 'react-router-dom'
import fetch from 'isomorphic-fetch'
import FaUser from 'react-icons/lib/fa/user'
import FaSignOut from 'react-icons/lib/fa/sign-out'
import Calendar from 'react-icons/lib/fa/calendar-check-o'
import MdDirectionsRun from 'react-icons/lib/md/directions-run'
import { func, object } from 'prop-types'

import MobileSessionMenu from '../MobileSessionMenu/MobileSessionMenu'
import styles from './SessionMenu.styl'

export default class SessionMenu extends React.Component {

	static propTypes = {
		dispatch: func,
		session: object
	}

	state = {
		isMenuOpen: false
	}
	get navigation() {
		const { session: { name } } = this.props
		return [
			{ name: 'Vista Diária', to: '/apt/workout/daily', icon: Calendar },
			{ name, to: '/apt/profile', icon: FaUser },
			{ name: 'Logout', icon: FaSignOut, action: this.handleRevoke.bind(this) }
		]
	}

	handleRevoke() {
		fetch('/api/accounts/revoke', {
			method: 'DELETE',
			credentials: 'include'
		})
			.then(() => {
				window.location = '/'
			})
			.catch(e => e)
	}
	render() {
		const { isMenuOpen } = this.state
		const { session } = this.props
		return (
			<section className={ styles['menu'] }>
				<div className={ styles['content'] }>
					<div className={ styles['mobile-menu-container'] }>
						{ isMenuOpen ?
							<MobileSessionMenu
								navigation={ this.navigation }
								className={ styles['mobile'] }
								closeMenu={ () => { this.setState({ isMenuOpen: false }) } }
							/> :
							null
						}
						<div className={ styles['mobile-menu-content'] } onClick={ () => { this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen })) } }>
							<NavLink to="/">
								<img className={ styles['logo'] } src="http://i.imgur.com/RFnxWBP.png" />
							</NavLink>
							<span className={ `${ styles['burger'] } ${ isMenuOpen ? styles['is-open'] : '' }` }><span /></span>
						</div>
					</div>
					<div className={ styles['desktop-container'] }>
						<div className={ styles['left-container'] }>
							<NavLink to="/">
								<img className={ styles['logo'] } src="http://i.imgur.com/RFnxWBP.png" />
							</NavLink>
						</div>
						<div className={ styles['session-container'] }>
							<NavLink activeClassName={ styles['active'] } to="/apt/plans" className={ styles['profile'] }>
								<div className={ styles.userName }>
									<strong>Planos</strong>
								</div>
								<div className={ styles.icon }><i><MdDirectionsRun /></i></div>
							</NavLink>
							<NavLink activeClassName={ styles['active'] } to="/apt/workout/daily" className={ styles['profile'] }>
								<div className={ styles.userName }>
									<strong>Vista Diária</strong>
								</div>
								<div className={ styles.icon }><i><Calendar /></i></div>
							</NavLink>
							<NavLink activeClassName={ styles['active'] } to="/apt/profile" className={ styles['profile'] }>
								<div className={ styles.userName }>
									<strong>{ session.name }</strong>
								</div>
								<div className={ styles.icon }><i><FaUser /></i></div>
							</NavLink>
							<div onClick={ this.handleRevoke } className={ styles['profile'] }>
								<div className={ styles.label }>
									<strong>Logout</strong>
								</div>
								<div className={ styles.icon }><i><FaSignOut /></i></div>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/SessionMenu/SessionMenu.js